import * as angular from 'angular';
import { UserAgent } from './user-agent.service';

export const UserAgentModalModule = angular.module('user-agent-modal-module', []).service('UserAgentModal', UserAgent)
  .name;
